class ajaxPagination extends HTMLElement {
    constructor() {
      super();

      const mainEl = document.querySelector("[js-main-collection]");
      const collectionId = mainEl ? mainEl.getAttribute('data-section-id') : null;

      this.sections = {
        main: {
            sectionId: collectionId,
            nodeId: "CollectionAjaxContent"
        }
      };

      this.ajaxCollectionEl = document.querySelector(`#${this.sections.main.nodeId}`);
      this.init();

      this.handleUpdateScroll = this.updateScroll.bind(this);
      document.addEventListener("update:scroll", this.handleUpdateScroll);
    };

    disconnectedCallback() {
      if (this.handleUpdateScroll) {
        document.removeEventListener("update:scroll", this.handleUpdateScroll);
      }
    }

    init() {
        const paginationItems = this.querySelectorAll("[js-pagination-item]");

        paginationItems.forEach( item => {
          item.addEventListener('click', evt => {
            const url = evt.currentTarget.getAttribute("href");
            if (url) {
              evt.preventDefault();
              this.initAjaxCollection(url);
            }
          });
        });
    }

    initAjaxCollection(url) {
        this.updateHistoryState(url);
        this.updateScroll();
        this.renderAjaxCollection(url);
    };

    updateHistoryState(url) {
        window.history.pushState({path: url}, '', url);
        if(document.querySelector('[data-canonical-url]')) {
          document.querySelector('[data-canonical-url]').setAttribute('href', window.location.href);
        }
    };

    updateScroll() {
        const scrollToElement = document.querySelector('[data-scroll-to]');
        let scrollTo = scrollToElement ? (scrollToElement.getBoundingClientRect().top + window.pageYOffset) : 0;

        let headerHeight = document.querySelector('sticky-header')?.offsetHeight || 0;
        if(document.querySelector('.Header_announcement_bar_new')) {
            headerHeight += document.querySelector('.Header_announcement_bar_new').offsetHeight;
        }
        scrollTo = Math.max(0, scrollTo - headerHeight - 20);
        window.scrollTo({top: scrollTo, behavior: 'smooth'});
    }

    renderAjaxCollection(url) {
        if (!this.ajaxCollectionEl) {
          this.ajaxCollectionEl = document.querySelector(`#${this.sections.main.nodeId}`);
        }
        if (this.ajaxCollectionEl) {
          this.ajaxCollectionEl.classList.add('loading');
        }

        fetch(url).then(response => {
            if (!response.ok) throw new Error('Network error');
            return response.text();
        }).then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            const newContent = doc.querySelector(`#${this.sections.main.nodeId}`);
            if (newContent && this.ajaxCollectionEl) {
              this.ajaxCollectionEl.innerHTML = newContent.innerHTML;
            }

            // Update product counts (e.g. "Showing 39-76 of 1527 items")
            const newCount = doc.querySelector('#ProductCount');
            if (newCount && document.querySelector('#ProductCount')) {
              document.querySelector('#ProductCount').innerHTML = newCount.innerHTML;
            }
            const newCountDesktop = doc.querySelector('#ProductCountDesktop');
            if (newCountDesktop && document.querySelector('#ProductCountDesktop')) {
              document.querySelector('#ProductCountDesktop').innerHTML = newCountDesktop.innerHTML;
            }

            // Re-initialize swipers and triggers
            if (typeof productCardSwiper === 'function') {
              productCardSwiper();
            }
            if (typeof initializeScrollAnimationTrigger === 'function') {
              initializeScrollAnimationTrigger(html);
            }
        }).catch(err => {
            console.error('Ajax pagination error:', err);
            window.location.href = url;
        }).finally(() => {
            if (this.ajaxCollectionEl) {
              this.ajaxCollectionEl.classList.remove('loading');
            }
        });
    }
}
  
customElements.define('ajax-pagination', ajaxPagination);

if (!window.ajaxPaginationPopstateBound) {
  window.ajaxPaginationPopstateBound = true;
  window.addEventListener('popstate', (e) => {
    if (e.state && e.state.path) {
      const ajaxEl = document.querySelector('ajax-pagination');
      if (ajaxEl && typeof ajaxEl.renderAjaxCollection === 'function') {
        ajaxEl.renderAjaxCollection(e.state.path);
        ajaxEl.updateScroll();
      } else {
        window.location.reload();
      }
    }
  });
}